import React, {useState} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { cartSizeSelector, cartSubtotalSelector, cartSubtotalTextilSelector } from 'redux/selectors/cart.selector';
import { formatCurrencyARS } from 'helpers/currency';
import CartContainer from 'containers/CartContainer';
import './CartPopup.scss';
import { Link } from 'react-router-dom';

const CartPopup = (props) => {
    const { cartSize, cartSubtotal, cartSubtotalTextil, client } = props;
    const cartTotal = client?.design === 3 ? cartSubtotalTextil : cartSubtotal;
    const cartTotalFormatted = formatCurrencyARS(cartTotal);

    const [isCartVisible, setCartVisible] = useState(false); 

    const toggleCart = () => {
      setCartVisible(!isCartVisible);
    }
    
    return  (
      <>
        <Link to='/carrito' className="cart-popup">
            <i className="fa fa-shopping-cart cart-popup-icon" aria-hidden="true" />
            <span id="checkout-items" className="checkout-items">
              {cartSize}
            </span>
            {!!Number(cartSize) && <span className="cart-popup-total">{cartTotalFormatted}</span>}
          </Link>
          
        {/* <div className={`cart-container mobile-cart ${isCartVisible ? 'visible' : ''}`}>
          <div className='cart-card-header' onClick={toggleCart}>
            <h4 className='text-center text-carrito'>Carrito de compras</h4>
            <button className="cart-close-button" onClick={toggleCart}> X</button>
          </div>
          <div className="cart-content">
            <CartContainer isCartVisible={isCartVisible} toggleCart={toggleCart}/>
          </div>
        </div> */}
      </>
    );
};
  
  const mapStateToProps = (state) => ({
    cartSize: cartSizeSelector(state),
    cartSubtotal: cartSubtotalSelector(state),
    cartSubtotalTextil: cartSubtotalTextilSelector(state),
    client: state.app.client,
  });

  CartPopup.defaultProps = {
    isCartVisible: false,
  };
  
  CartPopup.propTypes = {
    cartSize: PropTypes.number,
    cartSubtotal: PropTypes.number,
    cartSubtotalTextil: PropTypes.number,
    client: PropTypes.shape(),
  };
  
  export default connect(mapStateToProps)(CartPopup);
